<template>
  <component :is="'div'" name="termly-embed" data-id="0f05cbc5-105d-4df3-9f1c-948386eef1e9" data-type="iframe" />
</template>
